import React, { useEffect, useState } from "react";
import "./ChatAppV2.scss";

interface ChatAppV2Props {
  token?: string;
}

const ChatAppV2: React.FC<ChatAppV2Props> = ({ token }) => {
  const [iframeUrl, setIframeUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Get health coach information from localStorage
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    const healthCoachId = userInfo?.health_coach_id;
    const authToken = token || localStorage.getItem("token");

    // Construct health coach name from userInfo
    const healthCoachName = userInfo?.first_name && userInfo?.last_name 
      ? `${userInfo.first_name} ${userInfo.last_name}`
      : userInfo?.first_name || "Health Coach";

    // Create query parameters for the chat app
    const queryParams = new URLSearchParams({
      subscriberId: healthCoachId || "",
      hc_type: "hc",
      subscriberName: healthCoachName,
      token: authToken || ""
    });

    // Set the iframe URL
    const chatAppV2Url = `${process.env.REACT_APP_CHAT_APP_URL}?${queryParams.toString()}`;
    setIframeUrl(chatAppV2Url);
    setIsLoading(false);
  }, [token]);

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="chat-app-v2-container">
      <div className="chat-app-header">
        <h2>Chat App v2</h2>
      </div>
      
      {isLoading && (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading Chat App...</p>
        </div>
      )}

      {iframeUrl && (
        <iframe
          src={iframeUrl}
          className="chat-iframe"
          title="Chat App v2"
          onLoad={handleIframeLoad}
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
        />
      )}
    </div>
  );
};

export default ChatAppV2;
